import { circles } from "./circles";

export type Edge = "left" | "right" | "top" | "bottom";

export type CircleAnim = {
  id: number;
  edge: Edge;
  // offscreen position along the perpendicular axis (0-100)
  crossPercent: number;
  // how far outside the viewport (as percentage)
  outsidePercent: number;
  // scroll progress [0-1] where this circle starts moving
  startAt: number;
  // duration in scroll progress [0-1]
  duration: number;
};

// Deterministic pseudo-random so SSR/CSR and re-renders stay in sync.
function mulberry32(seed: number) {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function buildAnimConfig(): CircleAnim[] {
  const rand = mulberry32(20260708);
  const edges: Edge[] = ["left", "right", "top", "bottom"];
  const total = circles.length;

  return circles.map((c, i) => {
    const edge = edges[i % 4];
    const crossPercent = rand() * 100;
    // -15% to -30% for left/top, 110%-125% for right/bottom
    const magnitude = 15 + rand() * 15;
    const outsidePercent =
      edge === "left" || edge === "top" ? -magnitude : 100 + magnitude;

    const startAt = (i / total) * 0.55;
    const duration = 0.3 + rand() * 0.15;

    return {
      id: c.id,
      edge,
      crossPercent,
      outsidePercent,
      startAt,
      duration,
    };
  });
}

// power2.inOut easing (quadratic ease in-out)
export function easeInOut(t: number): number {
  if (t <= 0) return 0;
  if (t >= 1) return 1;
  return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
}

// simple linear clamp
export function clamp01(v: number): number {
  return v < 0 ? 0 : v > 1 ? 1 : v;
}